import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import BlurLoader from "./CommonComponents/BlurFullPageLoader";
import { GetSession, RemoveSession } from "./CommonComponents/criptoUtils";
import Header from "./Layout/Header";
import SideBar from "./Layout/SideBar";
import { deleteCookie, logout } from "./CommonComponents/EnvConfig";

const Protected = (Props) => {
    const { Component } = Props;
    const navigate = useNavigate();
    const [auth, setAuth] = useState(true);
    const subLoading = useSelector(state => state.auth.loading)
    const { open } = useSelector((state) => state.header);

    const checkLogin1 = async () => {
        const user = GetSession('cookies', 'user');
        if (!user?.loginToken || user?.loginToken === 'EXPIRED') {
            RemoveSession('cookies', 'user')
            deleteCookie('user')
            logout()
            navigate('/');
            setAuth(false);
        } else {
            setAuth(true);
        }
    };
    const checkLogin = async () => {
        setAuth(true);
    };

    useEffect(() => {
        checkLogin();
    }, [])

    return auth ? (
        <>
            <Header />
            <SideBar />
            <main id="main" className="main" style={open ? { marginLeft: "272px" } : { marginLeft: "15px" }}>
                <Component />
            </main>
            {subLoading && <BlurLoader />}
        </>
    ) : <></>
}
export default Protected;